export const MODAL_TYPES = {
  ada: 'ada',
  cs: 'cs',
  grace: 'grace',
  help: 'help',
  survey: 'survey',
  actual_ada: 'actual_ada',
};

export const STAGE_TYPES = {
  ingredientSelection: 'ingredient_selection',
  resolution: 'resolution',
  options: 'options',
  optionsWithSelectedBasket: 'options_with_selected_basket',
  mealSelection: 'meal_selection',
};

export const TEXT_BOX = {
  button: 'Continue',
  error: 'Please describe what went wrong to continue.',
};

export const GENERIC_ERROR = 'Something went wrong. Please try again later.';
export const HELP_WITH_A_DIFFERENT_ORDER = 'Help with a different order';
export const RESOLVED = 'resolved';
export const WHAT_DO_YOU_NEED_HELP_WITH = 'What do you need help with?';
export const ADA_RESOLUTION_STAGE_SLUG = 'ada-resolution';
export const CANCELLATION_STAGE_SLUG = 'cancel-order';
export const ENTRANCE_STAGE_SLUG = 'entrance-stage';
export const LIST_OPTIONS_SELECT_SLUG = 'list-options-select';
export const NOT_ARRIVED_NOT_LATE_SLUG = 'not-arrived-not-late';
export const NOT_ARRIVED_ONE_DAY_LATE_SLUG = 'not-arrived-one-day-late';
export const NOT_ARRIVED_TWO_DAYS_LATE_SLUG = 'not-arrived-two-days-late';

export const TRACKING_LINK_SLUGS = [
  NOT_ARRIVED_NOT_LATE_SLUG,
  NOT_ARRIVED_ONE_DAY_LATE_SLUG,
  NOT_ARRIVED_TWO_DAYS_LATE_SLUG,
];
